export default [
    {
        path: '/vote/sea-det',
        component: (resolve) => require(['@/components/vote/SeaDet'],resolve),
        meta:{
            title:'投票活动',
        }
    },

    {
        path: '/vote/sea-form',
        component: (resolve) => require(['@/components/vote/SeaForm'],resolve),
        meta:{
            title:'投票排行榜',
        }
    },
    {
        path: '/vote/sea-personal',
        component: (resolve) => require(['@/components/vote/SeaPersonal'],resolve),
        meta:{
            title:'投票人详情',
        }
    },

    {
        path: '/vote/sea-sign',
        component: (resolve) => require(['@/components/vote/SeaSign'],resolve),
        meta:{
            title:'投票报名',
        }
    },

    {
        path: '/vote/vote-det',
        component: (resolve) => require(['@/components/vote/VoteDet'],resolve),
        meta:{
            title:'自建投票详情',
        }
    },

    {
        path: '/vote/vote',
        component: (resolve) => require(['@/components/vote/Vote'],resolve),
        meta:{
            title:'投票中心',
        }
    },

    {
        path: '/vote/Vote-form',
        component: (resolve) => require(['@/components/vote/VoteForm'],resolve),
        meta:{
            title:'自建投票详情',
        }
    },

    {
        path: '/vote/vote-personal',
        component: (resolve) => require(['@/components/vote/VotePersonal'],resolve),
        meta:{
            title:'投票人详情',
        }
    },

]


// WEBPACK FOOTER //
// ./src/router/vote.js